import { render, staticRenderFns } from "./Dialog_AddSchoolScore.vue?vue&type=template&id=faf60250&scoped=true&"
import script from "./Dialog_AddSchoolScore.vue?vue&type=script&lang=js&"
export * from "./Dialog_AddSchoolScore.vue?vue&type=script&lang=js&"
import style0 from "./Dialog_AddSchoolScore.vue?vue&type=style&index=0&id=faf60250&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faf60250",
  null
  
)

export default component.exports